import { render, staticRenderFns } from "./DiagramRightDrawer.vue?vue&type=template&id=20b2ba40"
import script from "./DiagramRightDrawer.vue?vue&type=script&lang=js"
export * from "./DiagramRightDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports